
// [3D 아이콘 소스 URL] - Shared across App
export const ICONS = {
    teacher_male: "/images/teacher_3d_light.png",
    teacher_female: "/images/woman_teacher_3d_light.png",
    teacher_male_animated: "/images/teacher_animated_light.png",
    teacher_female_animated: "/images/woman_teacher_animated_light.png",
    teacher: "/images/Teacher.png",
    student: "/images/Student.png",
    attendance: "/images/Chart_increasing.png",
    money: "/images/Money_bag.png",
    calendar: "/images/Calendar.png",
    fire: "/images/Fire.png",
    check: "/images/Check_mark_button.png",
    muscle: "/images/Flexed_biceps.png",
    phone: "/images/Telephone_Receiver.png",
    warning: "/images/Warning.png",
    party: "/images/Party_popper.png",
    ok: "/images/OK_hand.png",
    siren: "/images/Police_car_light.png",
    memo: "/images/Memo.png",
    pencil: "/images/Pencil.png",
    sun: "/images/Sun.png",
    moon: "/images/Crescent_moon.png",
    sparkles: "/images/Sparkles.png",
    smilingfacewithheart: "/images/Smiling_face_with_hearts.png",
    glowingstar: "/images/Glowing_star.png",
    seedling: "/images/Seedling.png",
    lightbulb: "/images/Light_bulb.png",
    gift: "/images/Wrapped_gift.png",
    hearthands: "/images/Heart_hands.png",
    birthday: "/images/birthday_cake_animated.png",
    vote: "/images/Ballot_box_with_ballot.png",
    books: "/images/Books.png"
};
